module.exports = require('./dist');


//////////////////
// WEBPACK FOOTER
// ./~/vue-croppie/index.js
// module id = 212
// module chunks = 11